export default "__VITE_ASSET__CJ_4l1KB__"